<template>
  <div class="login-bg" :class="{ 'create-bg': emailInvitationInterface }">
    <video muted loop autoplay class="company-video" v-if="!emailInvitationInterface">
      <source src="@/assets/company-illustration.mp4" type="video/mp4" />
    </video>
    <video muted loop autoplay class="company-video" v-else>
      <source src="@/assets/email-illustration.mp4" type="video/mp4" />
    </video>
    <a v-if="companyManagementBtn" class="login-bg-tip" @click="open">
      {{ $t('Enterprise management background') }}
      <img src="@/assets/left-arrows.png" alt="" />
    </a>
  </div>
</template>

<script setup>
import { getCurrentInstance, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { isInWebview } from '@/libs/utils'
import { getAuthCode } from '@/api/user/user'
import { appStore } from '@/stores'
const $route = useRoute()

const $router = useRouter()
const { $t } = getCurrentInstance().proxy
const open = async () => {
  const details = $router.resolve({
    name: 'index',
    params: { action: 'companyManagement', lang: appStore.language },
    query: { isCN: 0 },
  })
  if (isInWebview()) {
    try {
      let dataUrl = location.host + details.href
      const { data } = await getAuthCode()
      dataUrl += `&code=${data.code}&userSync=1`
      window.open(dataUrl, '_blank')
    } catch (e) {
      console.log(e)
    }
  } else $router.push({ name: 'companyManagement' })
}
const companyManagementBtn = false // computed(() => $route.name === 'createInviteColleagues')
const emailInvitationInterface = computed(() => $route.name === 'createInviteColleagues')
</script>

<style lang="scss" scoped>
@keyframes tabs {
  0% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
.login-bg {
  overflow: hidden;
  width: 475px;
  height: 100%;
  background-color: #254cc8;
  background-size: 100%;
  position: relative;
  transition: all 0.5s linear;
  animation: tabs 1s linear 1;
  .login-bg-tip {
    color: #fff;
    cursor: pointer;
    position: absolute;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    text-decoration-line: underline;
    display: flex;
    align-items: center;
    justify-content: center;
    left: 0;
    right: 0;
    bottom: 50px;
    margin: 0 auto;
    text-align: center;
    img {
      width: 24px;
      height: 24px;
    }
  }
  .company-video {
    width: 100%;
    height: 100%;
  }
}
.create-bg {
  width: 386px;
  background-size: 100%;
}
</style>
